<template>
<div class="container pt-3 pb-4 mb-4">
  <div v-if="loading" class="text-center py-3"><i class="fas fa-spinner fa-spin"></i></div>
  <div v-else class="row">

    <!-- left -->
    <div class="col-md-6 col-12">
      <div class="profile">Profile<small class="ml-3">
        <a href="#/" @click="showEditProfile()" style="color:#0b79bf;">Update</a>
      </small></div>
      <buyer-profile :user="user"></buyer-profile>
    </div>

    <!-- right -->
    <div class="col-md-6 col-12 mt-3 mt-md-0">
      <div class="profile">Cards</div>
      <cards></cards>

      <div class="profile mt-4">Timezone<small class="ml-3">
        <a href="#/" @click="showChangeTimezone()" style="color:#0b79bf;">Change</a>
        </small></div>
      <div class="card">
        <div class="card-body text-center" v-if="user.timezone">
          {{timezoneDiff(user.timezone)}}
        </div>
      </div>
    </div>

  </div>
  <edit-profile :user="user"></edit-profile>
  <change-timezone :user="user"></change-timezone>
</div>
</template>

<script>
import { EventBus } from '../bus';

export default {

  data() {
    return {
      user: {},
      address: {},
      loading_collection: false,
      loading: false,
    };
  },

  created() {
    this.getUser();

    EventBus.$on('profile-updated', (user) => {
          this.user.name = user.name;
          this.user.surname = user.surname;
          this.user.email = user.email;
      });
  },

  methods: {
    showEditProfile() {
      this.$bvModal.show('bv-modal-edit-profile');
    },

    showChangeTimezone() {
      this.$bvModal.show('bv-modal-change-timezone');
    },

    getUser() {
      this.loading = true;
      axios.get('/profile/get')
        .then((response) => {
          this.user = response.data;
          this.loading = false;
        });
    },

  },

};
</script>

<style scoped>
.profile {
  font-size:1.1rem;
  padding-bottom:0.5rem;
}
</style>